module.exports = __webpack_public_path__ + "static/media/storePlovdiv.0ac1328a.png";